// ===== REQUIEM - Main JavaScript =====

// --- Toast Notification ---
function showToast(message, type) {
  const toast = document.getElementById('toast');
  if (!toast) return;
  toast.textContent = message;
  toast.className = 'toast visible ' + (type || 'success');
  setTimeout(() => toast.className = 'toast', 2500);
}

// --- Cart Added Popup ---
function showCartPopup(name, size, image, qty) {
  const overlay = document.getElementById('cartPopupOverlay');
  if (!overlay) return;
  document.getElementById('cartPopupItem').textContent = qty + 'x ' + name;
  document.getElementById('cartPopupSize').textContent = 'Size: ' + size;
  const img = document.getElementById('cartPopupImage');
  if (image) {
    img.src = image;
    img.style.display = 'block';
  } else {
    img.style.display = 'none';
  }
  overlay.classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeCartPopup() {
  const overlay = document.getElementById('cartPopupOverlay');
  if (overlay) overlay.classList.remove('active');
  document.body.style.overflow = '';
}

// --- Fetch Shopify Cart ---
async function fetchCart() {
  try {
    const response = await fetch('/cart.js');
    return await response.json();
  } catch (e) {
    return null;
  }
}

// --- Update Header Cart Count ---
async function updateCartCount(cart) {
  if (!cart) cart = await fetchCart();
  if (!cart) return;
  const count = cart.item_count || 0;
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = count;
    el.classList.toggle('visible', count > 0);
  });
}

// --- Add to Cart from Product Page ---
async function addToCartFromPage() {
  const btn = document.getElementById('addToCartBtn');
  const activeSize = document.querySelector('.size-btn.active');
  const size = activeSize ? activeSize.dataset.size : '';
  const variantId = activeSize ? activeSize.dataset.variantId : '';
  const nameEl = document.querySelector('.product-detail-name');
  if (!btn || !nameEl) return;
  if (!variantId) {
    showToast('Please select a size', 'error');
    return;
  }
  const btnEl = document.getElementById('addToCartBtn');
  btnEl.textContent = 'Adding...';
  btnEl.disabled = true;

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: selectedQty })
    });
    if (!response.ok) throw new Error('add failed');
    const item = await response.json();
    btnEl.textContent = 'Add to Cart';
    btnEl.disabled = false;
    updateCartCount();
    showToast(item.product_title + ' added to cart');
    showCartPopup(item.product_title, size, btn.dataset.image, selectedQty);
  } catch (e) {
    btnEl.textContent = 'Add to Cart';
    btnEl.disabled = false;
    showToast('Could not add to cart', 'error');
  }
}

// --- Buy Now ---
async function buyNow() {
  const activeSize = document.querySelector('.size-btn.active');
  const variantId = activeSize ? activeSize.dataset.variantId : '';
  if (!variantId) {
    showToast('Please select a size', 'error');
    return;
  }
  const btnEl = document.getElementById('buyNowBtn');
  const original = btnEl.textContent;
  btnEl.textContent = 'Processing...';
  btnEl.disabled = true;

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: selectedQty })
    });
    if (!response.ok) throw new Error('add failed');
    window.location.href = '/checkout';
  } catch (e) {
    btnEl.textContent = original;
    btnEl.disabled = false;
    showToast('Could not start checkout', 'error');
  }
}

// --- Change Cart Line (remove or update qty) ---
async function changeCartLine(lineKey, quantity) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    });
    if (!response.ok) throw new Error('change failed');
    const cart = await response.json();
    updateCartCount(cart);
    renderCartPage(cart);
  } catch (e) {
    showToast('Could not update cart', 'error');
  }
}

// --- Remove from Cart ---
async function removeFromCart(lineKey) {
  await changeCartLine(lineKey, 0);
}

// --- Update Cart Item Quantity ---
async function updateCartQty(lineKey, delta, btn) {
  const valueEl = btn.closest('.cart-item-qty').querySelector('.qty-value');
  const current = valueEl ? parseInt(valueEl.textContent, 10) : 1;
  const qty = Math.max(1, current + delta);
  await changeCartLine(lineKey, qty);
}

// --- Format Price ---
function formatPrice(amount) {
  return '\u20B9' + amount.toLocaleString('en-IN');
}

// --- Product Page Quantity ---
let selectedQty = 1;

function initQtySelector() {
  const minus = document.getElementById('qtyMinus');
  const plus = document.getElementById('qtyPlus');
  const value = document.getElementById('qtyValue');
  if (!minus || !plus || !value) return;
  selectedQty = 1;
  minus.addEventListener('click', () => {
    selectedQty = Math.max(1, selectedQty - 1);
    value.textContent = selectedQty;
  });
  plus.addEventListener('click', () => {
    selectedQty = Math.min(99, selectedQty + 1);
    value.textContent = selectedQty;
  });
}

// --- Render Cart Page ---
async function renderCartPage(cart) {
  const container = document.getElementById('cartPage');
  if (!container) return;

  if (!cart) cart = await fetchCart();
  if (!cart) return;

  const subtitle = document.getElementById('cartSubtitle');
  if (subtitle) {
    const totalItems = cart.item_count || 0;
    subtitle.textContent = totalItems + ' item' + (totalItems !== 1 ? 's' : '');
  }

  if (!cart.items || cart.items.length === 0) {
    container.innerHTML = `
      <div class="cart-empty">
        <h2>Your cart is empty</h2>
        <p>Add some fire to your wardrobe.</p>
        <a href="/collections/all" class="btn btn-primary">Shop Now</a>
      </div>
    `;
    return;
  }

  const subtotal = cart.total_price / 100;
  const shipping = 0;
  const total = subtotal;

  let itemsHTML = '';
  cart.items.forEach(item => {
    itemsHTML += `
      <div class="cart-item">
        <div class="cart-item-image">${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : 'Img'}</div>
        <div>
          <p class="cart-item-name">${item.product_title}</p>
          <p class="cart-item-variant">Size: ${item.variant_title}</p>
          <div class="cart-item-qty">
            <button class="qty-btn" data-line="${item.key}" data-change="-1">-</button>
            <span class="qty-value">${item.quantity}</span>
            <button class="qty-btn" data-line="${item.key}" data-change="1">+</button>
            <button class="cart-item-remove" data-line="${item.key}">Remove</button>
          </div>
        </div>
        <div class="cart-item-price">
          <p class="price">${formatPrice(item.price * item.quantity / 100)}</p>
          <p class="qty-info">${item.quantity} x ${formatPrice(item.price / 100)}</p>
        </div>
      </div>
    `;
  });

  container.innerHTML = `
    <div class="cart-items">${itemsHTML}</div>
    <div class="cart-summary">
      <div class="cart-summary-row">
        <span class="label">Subtotal</span>
        <span>${formatPrice(subtotal)}</span>
      </div>
      <div class="cart-summary-row">
        <span class="label">Shipping</span>
        <span>${shipping === 0 ? 'Free' : formatPrice(shipping)}</span>
      </div>
      ${shipping > 0 ? '<div style="font-size:11px;color:var(--text-dim);padding:4px 0;">Free shipping on orders above \u20B92,999</div>' : ''}
      <div class="cart-summary-row total">
        <span>Total</span>
        <span>${formatPrice(total)}</span>
      </div>
      <a href="/checkout" class="btn btn-primary checkout-btn">Proceed to Checkout</a>
    </div>
  `;
}

// --- Shop Filters ---
function initFilters() {
  const filterBtns = document.querySelectorAll('.filter-btn');
  const productCards = document.querySelectorAll('#shopGrid .product-card');

  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      filterBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const filter = btn.dataset.filter;
      productCards.forEach(card => {
        if (filter === 'all' || card.dataset.category === filter) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });
}

// --- Size Selector ---
function initSizeSelector() {
  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });
}

// --- Scroll Animations ---
function initScrollAnimations() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));
}

// --- Reveal Section Animations ---
function initRevealSection() {
  const heading = document.querySelector('.reveal-heading');
  const imageWrap = document.querySelector('.reveal-image-wrap');
  const info = document.querySelector('.reveal-info');
  const productImg = document.querySelector('.reveal-product-img');

  if (!heading) return;

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        heading.classList.add('revealed');
        setTimeout(() => imageWrap.classList.add('revealed'), 100);
        setTimeout(() => info.classList.add('revealed'), 250);
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  revealObserver.observe(heading);

  if (productImg) {
    window.addEventListener('scroll', () => {
      const rect = productImg.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      if (rect.top < windowHeight && rect.bottom > 0) {
        const progress = (windowHeight - rect.top) / (windowHeight + rect.height);
        const translateY = (progress - 0.5) * -20;
        productImg.style.transform = `translateY(${translateY}px)`;
      }
    }, { passive: true });
  }
}

// --- Floating Leaves ---
function initHeroSway() {
  const section = document.querySelector('.home-hero');
  if (!section) return;

  const container = document.createElement('div');
  container.style.cssText = `
    position: absolute; inset: 0; pointer-events: none; overflow: hidden;
  `;
  section.appendChild(container);

  const baseColors = ['rgba(160,180,100,0.5)', 'rgba(140,160,80,0.4)', 'rgba(180,200,120,0.3)', 'rgba(120,140,70,0.4)'];
  const visibleColors = ['rgba(170,190,110,0.8)', 'rgba(150,170,90,0.7)', 'rgba(190,210,130,0.6)'];
  const anims = ['leafDrift', 'leafDrift2', 'leafDrift3'];

  for (let i = 0; i < 30; i++) {
    const leaf = document.createElement('div');
    const size = 8 + Math.random() * 10;
    const isVisible = i < 6;
    const color = isVisible ? visibleColors[i % visibleColors.length] : baseColors[i % baseColors.length];
    leaf.style.cssText = `
      position: absolute;
      width: ${size}px;
      height: ${size * 0.5}px;
      background: ${color};
      border-radius: 50% 0 50% 0;
      top: ${5 + Math.random() * 55}%;
      left: -40px;
      animation: ${anims[i % anims.length]} ${6 + Math.random() * 8}s linear infinite;
      animation-delay: ${i * 0.5}s;
      opacity: ${isVisible ? 0.35 : 0.15};
    `;
    container.appendChild(leaf);
  }
}

// --- Mobile Menu ---
function initMobileMenu() {
  const btn = document.getElementById('mobileMenuBtn');
  const overlay = document.getElementById('mobileNavOverlay');
  const close = document.getElementById('mobileNavClose');
  if (!btn || !overlay) return;

  btn.addEventListener('click', () => overlay.classList.add('active'));
  if (close) {
    close.addEventListener('click', () => overlay.classList.remove('active'));
  }
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) overlay.classList.remove('active');
  });
  document.querySelectorAll('.mobile-nav-link').forEach(link => {
    link.addEventListener('click', () => overlay.classList.remove('active'));
  });
}

// --- Size Chart ---
function initSizeChart() {
  const btn = document.getElementById('sizechartBtn');
  const overlay = document.getElementById('sizechartOverlay');
  const close = document.getElementById('sizechartClose');
  const modal = document.getElementById('sizechartModal');
  if (!btn || !overlay) return;
  btn.addEventListener('click', openSizeChart);
  if (close) close.addEventListener('click', closeSizeChart);
  if (modal) modal.addEventListener('click', e => e.stopPropagation());
  overlay.addEventListener('click', closeSizeChart);
}

function openSizeChart() {
  document.getElementById('sizechartOverlay').classList.add('active');
  document.body.style.overflow = 'hidden';
}
function closeSizeChart() {
  document.getElementById('sizechartOverlay').classList.remove('active');
  document.body.style.overflow = '';
}

// --- Cart Added Popup Handlers ---
function initCartPopup() {
  const overlay = document.getElementById('cartPopupOverlay');
  const box = document.getElementById('cartPopupBox');
  const close = document.getElementById('cartPopupClose');
  const continueBtn = document.getElementById('cartPopupContinue');
  if (!overlay) return;
  if (close) close.addEventListener('click', closeCartPopup);
  if (continueBtn) continueBtn.addEventListener('click', closeCartPopup);
  if (box) box.addEventListener('click', e => e.stopPropagation());
  overlay.addEventListener('click', closeCartPopup);
}

// --- Product Gallery (swipe + thumbnails) ---
function initProductGallery() {
  const track = document.getElementById('galleryTrack');
  if (!track) return;
  const slides = track.querySelectorAll('.gallery-slide');
  const total = slides.length;
  let current = 0;

  const prevBtn = document.getElementById('galleryPrev');
  const nextBtn = document.getElementById('galleryNext');
  const thumbs = document.querySelectorAll('.gallery-thumb');

  function goTo(index) {
    if (total === 0) return;
    if (index < 0) index = total - 1;
    if (index >= total) index = 0;
    current = index;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    thumbs.forEach((t, i) => t.classList.toggle('active', i === current));
  }

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => goTo(parseInt(thumb.dataset.index, 10)));
  });
  if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

  let startX = 0;
  let startY = 0;
  track.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, { passive: true });
  track.addEventListener('touchend', (e) => {
    const dx = e.changedTouches[0].clientX - startX;
    const dy = e.changedTouches[0].clientY - startY;
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
      if (dx < 0) goTo(current + 1);
      else goTo(current - 1);
    }
  }, { passive: true });
}

// --- Profile Dropdown ---
function initProfileDropdown() {
  const btn = document.getElementById('profileBtn');
  const dropdown = document.getElementById('profileDropdown');
  if (!btn || !dropdown) return;
  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    dropdown.classList.toggle('active');
  });
  document.addEventListener('click', (e) => {
    if (!btn.contains(e.target)) dropdown.classList.remove('active');
  });
}

// --- Init ---
document.addEventListener('DOMContentLoaded', () => {
  updateCartCount();
  initFilters();
  initSizeSelector();
  initQtySelector();
  initScrollAnimations();
  initRevealSection();
  initHeroSway();
  initMobileMenu();
  initSizeChart();
  initCartPopup();
  initProfileDropdown();
  initProductGallery();

  const addToCartBtn = document.getElementById('addToCartBtn');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', addToCartFromPage);
  }

  const buyNowBtn = document.getElementById('buyNowBtn');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', buyNow);
  }

  if (document.getElementById('cartPage')) {
    renderCartPage();
    document.getElementById('cartPage').addEventListener('click', (e) => {
      const removeBtn = e.target.closest('.cart-item-remove');
      if (removeBtn) {
        removeFromCart(removeBtn.dataset.line);
        return;
      }
      const qtyBtn = e.target.closest('.qty-btn[data-change]');
      if (qtyBtn) {
        updateCartQty(qtyBtn.dataset.line, parseInt(qtyBtn.dataset.change, 10), qtyBtn);
      }
    });
  }
});
